/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAbsence } from '../models/work-absence';
import { WorkCreateAbsenceDto } from '../models/work-create-absence-dto';
import { WorkUpdateAbsenceDto } from '../models/work-update-absence-dto';

@Injectable({ providedIn: 'root' })
export class WorkAbsencesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `absencesV1ControllerCreate()` */
  static readonly AbsencesV1ControllerCreatePath = '/v1/absences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV1ControllerCreate$Response(
    params: {
      body: WorkCreateAbsenceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbsence>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesService.AbsencesV1ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbsence>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV1ControllerCreate(
    params: {
      body: WorkCreateAbsenceDto
    },
    context?: HttpContext
  ): Observable<WorkAbsence> {
    return this.absencesV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbsence>): WorkAbsence => r.body)
    );
  }

  /** Path part for operation `absencesV1ControllerUpdate()` */
  static readonly AbsencesV1ControllerUpdatePath = '/v1/absences/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV1ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateAbsenceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesService.AbsencesV1ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV1ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateAbsenceDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.absencesV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
